import React from 'react';
import PropTypes from 'prop-types';
import { useOidc } from '@axa-fr/react-oidc';
import { useHeaderLinks } from 'providers/AreasProvider';
import { getOidcConfigName } from 'utils/functions';

function HeaderLinks() {
  const [headerLinks] = useHeaderLinks();
  const { isAuthenticated } = useOidc(getOidcConfigName());

  return isAuthenticated ? headerLinks : <></>;
}

HeaderLinks.propTypes = {
  userProfile: PropTypes.object
};

export default HeaderLinks;
